

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../BaseUrl";
import { toastError, toastSuccess } from "../../AlertMessage/AlertMessage";

// Get Table Data
export const UserCreationMasterTableDataAPI = createAsyncThunk("UserCreationMasterTableData", async ({ data }) => {
    const {
        M_RoleManagerID,
        M_DepartmentMasterID,
        M_TableUserMasterID,
        M_DesignationMasterID,
        StatusIndicatorMasterID,
        From,
        To,
        UserID,
        token
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/Master/Get_M_TableUserMaster_Select?M_TableUserMasterID=${M_TableUserMasterID}&M_RoleManagerID=${M_RoleManagerID}&M_DesignationMasterID=${M_DesignationMasterID}&M_DepartmentMasterID=${M_DepartmentMasterID}&StatusIndicatorMasterID=${StatusIndicatorMasterID}&UserID=${UserID}&FromTop=${From}&ToTop=${To}`, requestOptions)
        .then((res) => {
            if (res.status == 401) {
                toastError('401')
            }
            if (res.status > 300 && res.status != 401) {
                toastError('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if (result.code >= 200 && result.code <= 300) {
                if (result.data) {
                    return result.data
                } else {
                    return result
                }
            } else {
                // toastError(result.message)
                return result
            }
        })
})

const UserCreationMasterTableDataSlice = createSlice({
    name: "UserCreationMasterTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(UserCreationMasterTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(UserCreationMasterTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(UserCreationMasterTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastError('Something went wrong')
        });
    },
})

export const UserCreationMasterTableDataReducer = UserCreationMasterTableDataSlice.reducer


// Export Get Table Data
export const UserCreationMasterExportTableDataAPI = createAsyncThunk("UserCreationMasterExportTableData", async ({ data }) => {
    const {
        M_DepartmentNameMasterID,
        M_TableUserMasterID,
        M_DesignationMasterID,
        StatusIndicatorMasterID,
        IsPortalAdmin,
        FromTop,
        ToTop,
        UserID,
        token
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch(`${BaseUrl}/EMS/Master/Get_M_TableUserMaster_Select?M_TableUserMasterID=${M_TableUserMasterID}&M_OfficeMasterID=1&M_DesignationMasterID=${M_DesignationMasterID}&M_DepartmentNameMasterID=${M_DepartmentNameMasterID}&StatusIndicatorMasterID=${StatusIndicatorMasterID}&IsPortalAdmin=${IsPortalAdmin}&UserID=${UserID}&FromTop=${FromTop}&ToTop=${ToTop}`, requestOptions)
        .then((res) => {
            if (res.status == 401) {
                toastError('401')
            }
            if (res.status > 300 && res.status != 401) {
                toastError('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if (result.code >= 200 && result.code <= 300) {
                if (result.data) {
                    return result.data
                } else {
                    return result
                }
            } else {
                toastError(result.message)
                return result
            }
        })
})

const UserCreationMasterExportTableDataSlice = createSlice({
    name: "UserCreationMasterExportTableData",
    initialState: {
        isExportLoading: false,
        ExporttableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(UserCreationMasterExportTableDataAPI.pending, (state, action) => {
            state.isExportLoading = true;
        });
        builder.addCase(UserCreationMasterExportTableDataAPI.fulfilled, (state, action) => {
            state.isExportLoading = false;
            state.ExporttableData = action.payload;
        });
        builder.addCase(UserCreationMasterExportTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isExportLoading = false;
            state.isError = true;
            state.ExporttableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const UserCreationMasterExportTableDataReducer = UserCreationMasterExportTableDataSlice.reducer


// InsertUpdate Table Data
export const UserCreationPostAPI = createAsyncThunk("UserCreationPost", async ({ data }) => {
    const {
        M_DepartmentMasterID,
        M_TableUserMasterID,
        M_RoleManagerID,
        M_DesignationMasterID,
        M_EmployeeMasterID,
        TableNameNo,
        UserName,
        Password,
        StatusIndicatorMasterID,
        JoiningDate,
        UserID,
        Flag,
        token,
        handleIsPost
    } = data


    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    formdata.append("M_TableUserMasterID", M_TableUserMasterID);
    formdata.append("M_RoleManagerID", M_RoleManagerID);
    formdata.append("M_DepartmentMasterID", M_DepartmentMasterID);
    formdata.append("M_DesignationMasterID", M_DesignationMasterID);
    formdata.append("M_EmployeeMasterID", M_EmployeeMasterID);
    formdata.append("TableNameNo", TableNameNo);
    formdata.append("UserName", UserName);
    formdata.append("Password", Password);
    formdata.append("StatusIndicatorMasterID", StatusIndicatorMasterID);
    formdata.append("JoiningDate", JoiningDate);
    formdata.append("Flag", Flag);
    formdata.append("UserID", UserID);

    var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata
    };

    fetch(`${BaseUrl}/Master/Post_M_TableUserMaster_InsertUpdateDelete`, requestOptions)
        .then((res) => {
            if (res.status == 401) {
                toastError('401')
            }
            if (res.status > 300 && res.status != 401) {
                toastError('Something went wrong')
            }
            return res.json()
        })
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.status) {
                handleIsPost()
                toastSuccess(result.message)
            } else {
                toastError(result.message)
            }
            return result
        })
})

const UserCreationPostSlice = createSlice({
    name: "UserCreationPost",
    initialState: {
        isPostLoading: false,
        PostData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(UserCreationPostAPI.pending, (state, action) => {
            state.isPostLoading = true;
        });
        builder.addCase(UserCreationPostAPI.fulfilled, (state, action) => {
            state.isPostLoading = false;
            state.PostData = action.payload;
        });
        builder.addCase(UserCreationPostAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isPostLoading = false;
            state.isError = true;
            state.PostData = null;

        });
    },
})

export const UserCreationPostReducer = UserCreationPostSlice.reducer